module.exports = __webpack_public_path__ + "static/media/Sultan Al-Hamidi.4961b72a.jpg";